import { ApiResponse } from "./../common/interfaces";

const baseURL = `${process.env.REACT_APP_BLOB_STORAGE_BASE_URL}`;

export async function GetLanguageStrings(
	selectedLanguage: string
): Promise<ApiResponse<any>> {
	// TODO: change baseURL/containerName from path where json files are deployed
	const container = "language";
	const res = await fetch(`${baseURL}/${container}/${selectedLanguage}.json`);
	if (res.ok) {
		try {
			const resData = await res.json();
			return {
				responseObj: resData,
			};
		} catch (err) {
			return {
				error: "failed to parse response returned by server",
			};
		}
	} else {
		return {
			error: `${res.status} - ${res.statusText || ""}`,
		};
	}
}
